module.exports = __webpack_public_path__ + "img/collar_edges_length.ba9c1aaa.png";